$(document).ready(function() {
	$('body').on('click','.swell-custom-refer-campaign',function(){
		if(spapi.authenticated == true )
			window.location.href='/pages/refer';
	});
	$(document).on("swell:setup", function() {
		SwellConfig.Faq.initializeFaqs(".swell-question-button, .swell-question-list");
		initCampaigns();
		campaignComplete();
	});
});

    (function() {
      window.SwellConfig = window.SwellConfig || {};

      SwellConfig.Faq = {
        initializeFaqs: function(containerSelector) {
          var collapsed_text, expanded_text;
          expanded_text = "Show Less <i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i>";
          collapsed_text = "Show All FAQs <i class=\"fa fa-chevron-down\" aria-hidden=\"true\"></i>";
          return $(containerSelector).click(function(e) {
            var $swell_question_list;
            if ($(e.target).is(containerSelector)) {
              $swell_question_list = $(".swell-question-list");
              $swell_question_list.toggleClass("swell-question-list-expanded");
              return $(".swell-question-button").html($swell_question_list.hasClass("swell-question-list-expanded") ? expanded_text : collapsed_text);
            }
          });
        }
      };
    }).call(this);

    (function() {
      var classNames, selectors,
      indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

      classNames = {
        container: "swell-question-content",
        heading: "swell-question-heading",
        section: "swell-question-details",
        open: "swell-question-open"
      };

      selectors = {
        container: "." + classNames.container,
        heading: "." + classNames.heading,
        section: "." + classNames.section,
        open: "." + classNames.open
      };

      $(document).ready(function() {
        var hash, heading, openCollapsiblesForAnchor, toHide;
        openCollapsiblesForAnchor = function(hash, redirect) {
          var anchors, el, name;
          name = hash.substr(1);
          anchors = $(selectors.container).find(hash + ", a[name=\"" + name + "\"]");
          if (anchors.length > 0) {
            el = $(anchors[0]);
            el.closest(selectors.container).find(selectors.heading).click();
            return el.closest(selectors.section).promise().done(function() {
              return window.location = redirect;
            });
          } else if ($(hash).is(selectors.container)) {
            return $(hash).find(selectors.heading).click();
          }
        };
        $(selectors.container).css("overflow", "hidden");
        toHide = $(selectors.container).not(selectors.open).find(selectors.section);
        heading = $(selectors.heading);
        toHide.hide();
        heading.css("cursor", "pointer");
        heading.click(function() {
          var parent, t;
          t = $(this);
          parent = t.parent();
          if (parent.hasClass(classNames.open)) {
            parent.removeClass(classNames.open);
            t.attr("aria-expanded", "false");
          } else {
            parent.addClass(classNames.open);
            t.attr("aria-expanded", "true");
          }
          t.next().slideToggle("fast");
          return false;
        });
        $(document).keydown(function(e) {
          if ((32 === e.keyCode || 13 === e.keyCode) && $(e.target).hasClass(classNames.heading)) {
            e.preventDefault();
            e.target.click();
            return false;
          }
        });
        if (window.location.hash) {
          hash = window.location.hash;
          openCollapsiblesForAnchor(hash, window.location);
        }
        if (indexOf.call(window, "onhashchange") >= 0) {
          return $(window).bind("hashchange", function(e) {
            hash = window.location.hash;
            return openCollapsiblesForAnchor(hash, window.location);
          });
        }
      });
    }).call(this);


function campaignComplete(){
	if(spapi.authenticated) {
		var campaigns=spapi.activeCampaigns;
		campaigns.forEach(function(campaign){
		  if(campaign.customerCompleted) {
		    $("div[ aria-label= '"+campaign.type+"']").css("opacity","0.4");          
		  } 
		});
	}
}
function referTile(){
  $(".yotpo-widget-campaign-widget-container .flexified-wrapper").append('<div role="listitem" aria-label="FacebookShareCampaign" tabindex="0" class="swell-custom-refer-campaign flexified-child yotpo-outer-tile" style="border-color: rgb(132, 140, 163);"> <div class="yotpo-campaign-switcher-wrapper"> <div class="yotpo-tile-wrapper"> <div class="yotpo-tile yotpo-campaign-tile-facebooksharecampaign" style="background-color: rgb(249, 250, 255);"> <div class="yotpo-widget-campaign-widget-icon-container"><img alt="icon" src="https://cdn-widget-assets.yotpo.com/static_assets/ML3JguhJYIIaTkfugM8YYA/images/image_2020_08_24_08_16_22_481" class="yotpo-widget-campaign-widget-custom-icon"></div> <div class="yotpo-headline-center-element"> <!----> <div class="yotpo-title-text" style="color: rgb(1, 18, 71); font-size: 16.2px; font-family: Montserrat; font-weight: 600; font-style: normal;">100 Points</div> </div> <div class="yotpo-description-text" style="color: rgb(78, 87, 114); font-size: 12px; font-family: Montserrat; font-weight: 400; font-style: normal;">Refer A Friend</div> </div> </div> <!----> </div> </div>')
}
function campaignHover() {
  if (!spapi.authenticated) {
    return $(".yotpo-campaign-switcher-wrapper .yotpo-tile-wrapper").hover(function() {
      return $(this).append('<div class="yotpo-logged-out-tile" style="background-color: rgb(1, 18, 71); color: rgb(255, 255, 255);"><!----><div class="yotpo-action-button-widget yotpo-submit-button yotpo-sign-up-button"><button class="yotpo-button-style yotpo-standard-size yotpo-filled-button yotpo-rectangular-btn-type" onClick="window.location.href="/account/register"" style="background: rgb(255, 255, 255); color: rgb(20, 0, 96); font-size: 16px; font-family: Montserrat; font-weight: 600;">Sign up</button></div><div class="yotpo-logged-out-center-element" style="font-family: Montserrat; font-weight: 400; color: rgb(255, 255, 255);"><div style="font-family: Montserrat;">Already a member?</div><a href="//www.ameswalker.com/account/login?checkout_url=https://www.ameswalker.com/pages/rewards" class="yotpo-sign-in-button" style="font-family: Montserrat; color: rgb(255, 255, 255);">Log in</a></div></div>');
    }, function() {
      return $(this).find(".yotpo-logged-out-tile").remove();
    });
  }
}

function initCampaigns(){
	var customer=spapi.customer;
  var campaigns=spapi.activeCampaigns;
	if(spapi.authenticated ) {
		  if( customer.vip_tier &&  customer.vip_tier.id == 4243 ) {
		  	$('.swell-campaign-section-2 .yotpo-widget-campaign-widget').css('display', 'block');
		  } 
		  else if( customer.vip_tier &&  customer.vip_tier.id == 4244 ) {
		  	$('.swell-campaign-section-3 .yotpo-widget-campaign-widget').css('display', 'block');
		  } 
		  else {
		  	$('.swell-campaign-section-1 .yotpo-widget-campaign-widget').css('display', 'block');
		  } 
	}
	else {
  	$('.swell-campaign-section-1 .yotpo-widget-campaign-widget').css('display', 'block');
  }
  referTile();
  campaignHover();
}
